import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import sortBy from 'lodash.sortby';

import { getActiveOrders } from '../../actions/orderActions';
import {
  Header,
} from '../Styles/index';
import OrdersTable from './OrderTable';

const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 32px 16px;
` 
const TableContainer = styled.div`

`

class ActiveOrders extends Component {

  state = {
    orders: [],
    orderBy: 'no',
    orderByItems: ['no', 'date', 'amount', 'client'],
  }

 

  _orderBy(value){
    switch (value) {
      case 'date':
        return sortBy(this.state.orders, value =>  new Date(value.date));
      case 'amount': 
        return sortBy(this.state.orders, order => {
          let amount = 0;
          for (const key in order.products) {
            amount += order.products[key];
          }
          return amount
        });
      case 'client':
        return sortBy(this.state.orders, order => order.client.name)
      default:
        return sortBy(this.state.orders, [value]);
    }
  }

  _handleChange = (event, index, value) => {
    const orders = this._orderBy(value);
    console.log(orders)
    this.setState({
      orderBy: value,
      orders
    });
  }

  _goToEditPage = (code) => {
    this.props.history.push(`/orders/edit?order=${code}`);
  }

  _refreshPage = () => {
   
  }


  async componentWillMount() {
    await this.props.getActiveOrders();
    if (this.props.activeOrders.status === 'fetched') {
      this.setState({
        orders: this.props.activeOrders.data
      })
    }
  }

  render(){
    // const tableHeader = ['No', 'Date', 'Amount', 'Client', 'Status', 'Notes', ''];
    const tableHeader = ['No', 'Date', 'Amount', 'Client', 'Status', 'Active', 'Notes', ''];
    return(
      <Container>
        <Header>
          <div style={{flex: 1, height: '74px', paddingRight: '24px'}}>
            <SelectField
              floatingLabelText="Sort By"
              value={this.state.orderBy}
              onChange={this._handleChange}
            >
              {this.state.orderByItems.map((item, index) => <MenuItem key={index} value={item} primaryText={item}/>)}
            </SelectField>
          </div>
        </Header>
          <div>
            <TableContainer>
              { !this.props.activeOrders.loading && <OrdersTable  
                refreshPage={this._refreshPage}  
                headers={tableHeader} 
                editHandler={this._goToEditPage} 
                tableData={this.state.orders} 
                height={this.props.activeOrders.data.length*48}
              />}
            </TableContainer>
          </div>
      </Container>
    )
  }
}

const mapStateToProps = state => ({ activeOrders: state.order.activeOrders });
const mapDispatchToProps = { getActiveOrders };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActiveOrders));



// WEBPACK FOOTER //
// ./src/components/Orders/ActiveOrders.js